module.exports = __webpack_public_path__ + "static/quad-img-3-89a95fa0dd364b0c51fdd2e6f50fa3dd.jpeg";